module.exports = __webpack_public_path__ + "img/logo.486052af.png";